<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('roomMap/setIsShowAddRoomMapStatus', false)">
            {{$t('com.file.room-map-settings.rooms-plans')}}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{$t('com.file.edit-announcement.name')}}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input"
                       type="text"
                       v-model="roomMap.name"
                       :placecholder="$t('com.file.edit-announcement.name')" />               
            </section>
            <label class="esesja-modal__wraper__body__label">{{$t('com.file.add-placeholder.board-description')}}</label>
            <section class="esesja-modal__row">
                <textarea class="esesja-modal__wraper__body__input"
                          v-model="roomMap.description"
                          :placecholder="$t('com.file.add-placeholder.description')" >
                </textarea>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('roomMap/setIsShowAddRoomMapStatus', false)">
                {{ $t('com.global.cancel') }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave :disabled="roomMap.name.length < 3" @save="saveRoomMap">
                {{ $t('com.global.save') }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
    import RoomMapService from "@/services/room.map.service";
    import AlertHelper from '@/helpers/alerts.helper.js';

    export default {
        name: "AddRoomMap",
        computed:{
            selectedRoomMap(){
                return this.$store.state.roomMap.selectedRoomMap;
            }
        },
        data(){
            return {
                roomMap:{
                    id: null,
                    name: "",
                    description: ""
                }
            }
        },
        mounted(){
            if (this.selectedRoomMap !== null){
                this.roomMap.id = this.selectedRoomMap.id;
                this.roomMap.name = this.selectedRoomMap.name;
                this.roomMap.description = this.selectedRoomMap.description ?? "";
            }
        },
        methods: {
            async saveRoomMap(){
                if (this.roomMap.id !== null) {
                    await this.internalUpdateRoomMap();
                }
                else {
                    await this.internalSaveRoomMap();
                }
            },
            async internalUpdateRoomMap(){
                try{
                    this.$store.commit("showLoader");

                    await RoomMapService.Update(this.roomMap.id, this.roomMap);

                    this.$store.commit('roomMap/setIsShowAddRoomMapStatus', false)
                }
                catch(e){

                    if (e.response !== undefined) {
                        var t = this.$swal.mixin(AlertHelper.errorToastElement());
                        t.fire(AlertHelper.errorToastAlert(this.$t('com.global.default-save-error'), this.$t('com.global.error')));
                    }
                }
                finally{
                    this.$store.commit("hideLoader");
                }
            },
            async internalSaveRoomMap(){
                try {
                    console.log("jestem")
                    this.$store.commit("showLoader");

                    await RoomMapService.Create(this.roomMap);

                    this.$store.commit('roomMap/setIsShowAddRoomMapStatus', false)
                }
                catch (e) {
                    if (e.response !== undefined) {
                        var t = this.$swal.mixin(AlertHelper.errorToastElement());
                        t.fire(AlertHelper.errorToastAlert(this.$t('com.global.default-save-error'), this.$t('com.global.error')));
                    }
                }
                finally{
                    this.$store.commit("hideLoader");
                }
            }
        }
    }
</script>
<style lang="scss">
    .esesja-modal__wraper__body__input__file {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;


        &::file-selector-button {
            background: #fff;
            padding: 12.5px 15px;
            border: none;
            transition: all 0.2s ease-in-out;
            cursor: pointer;

            &:hover {
                background: #e8ebef;
            }
        }
    }

    .esesja-modal__wraper__body__label__info {
        font-size: 0.8em
    }
</style>
